<template>
    <div>
        <head-layout />

        <v-row class="secondary--text">
            <v-col>
                <div class="text-h4">
                    King Sound Reinforcement Hire Catalogue
                </div>

                <div class="text-subtitle-1 mt-4">Browse our hire stock</div>
            </v-col>
        </v-row>

        <div class="row my-4">
            <div class="col">
                <product-search />
            </div>
        </div>

        <gallery-grid
            :items="$page.props.departments"
            :route-function="(item) => route('catalogue.department', item.slug)"
            hide-title
        >
            <template v-slot:image="{ item }">
                <v-img
                    :src="item.image"
                    eager
                    width="100%"
                    :aspect-ratio="8 / 7"
                    class="d-flex align-center"
                >
                    <div class="d-flex flex-column align-center">
                        <v-avatar
                            v-if="item.icon_url"
                            class="mb-2"
                            tile
                            size="40%"
                        >
                            <v-img :src="item.icon_url" contain eager />
                        </v-avatar>

                        <div
                            class="
                                white--text
                                text-h5 text-uppercase text-center
                            "
                            v-text="item.name"
                        />
                    </div>
                </v-img>
            </template>
        </gallery-grid>

        <how-to-hire />
    </div>
</template>

<script>
import GalleryGrid from "@/Components/Catalogue/GalleryGrid";
import HeadLayout from "@/Layouts/HeadLayout";
import HowToHire from "@/Components/Catalogue/HowToHire";
import ProductSearch from "@/Components/Catalogue/ProductSearch";

export default {
    name: "Departments",
    components: { ProductSearch, HowToHire, HeadLayout, GalleryGrid },
};
</script>

<style scoped>
.v-card__text {
    font-size: 1rem;
}
</style>
